exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td[data-v-73ede3ab]{padding:10px!important;padding-top:5px;border-bottom:1px solid #ddd;border-top:0 solid #ddd;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73ede3ab","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/procedure/procedureschedule-tag.vue
// module id = 1192
// module chunks = 0